<template>
  <div :class="$style.volumeController" @click="$emit('toggleMute')" @mouseover="showController = true" @mouseout="showController = false">
    <span :class="[$style.icon, (value === 0 || muted) && $style.disable]"></span>
    <div :class="$style.progressWrap" v-show="showController" @click.stop>
      <VueSlider
        v-model="value"
        tooltip="none"
        :max="1"
        :interval="0.1"
        :width="3"
        :height="58"
        :dotSize="15"
        :duration="0"
        direction="btt"
        :class="$style.progress"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import VueSlider from 'vue-slider-component'
import './css/slider.css'

export default {
  name: 'VolumenController',
  components: { VueSlider },
  data () {
    return {
      showController: false
    }
  },
  computed: {
    ...mapState(['muted', 'volume']),
    value: {
      get () {
        return !this.muted ? this.volume : 0
      },
      set (val) {
        this.$emit('onVolumeChange', val)
      }
    }
  }
}
</script>

<style lang="scss" module>
.volumeController {
  display: inline-block;
  width: 25px;
  text-align: center;
}

.icon {
  display: inline-block;
  width: 24px;
  height: 24px;
  cursor: pointer;
  background: url('./assets/horn_icon.svg') no-repeat;

  &.disable {
    background: url('./assets/horn_icon_disable.svg') no-repeat;
  }
}

.progressWrap {
  margin-top: 4px;
  width: 25px;
  height: 82px;
  background:#fff;
  box-shadow: 0 0 5px 0 rgba(81, 88, 113, 0.15);
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>
